import { spacer8 } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { MAX_CONTENT_SCREEN_WIDTH, MAX_CONTENT_WIDTH, MD_GRID_MAX_WIDTH, ONE_COLUMN_MAX_WIDTH, TWO_COLUMN_MAX_WIDTH, } from '../../Grid';
export const EmblaContainer = styled.div `
  --number-of-vids-to-show: ${({ numberOfVideosToShow }) => numberOfVideosToShow};
  --num-videos: ${({ numVideos }) => numVideos};
  --scroll-dist: ${({ scrollDist }) => scrollDist};
  // gap between each video
  --gap: ${spacer8};

  display: flex;
  padding-inline-start: var(--gap);
  gap: var(--gap);
  height: 100%;

  & .embla__slide {
    flex: ${({ isCompact }) => isCompact
    ? '0 0 60%'
    : `0 0 calc(
        (
            ${MAX_CONTENT_WIDTH} -
              ((var(--number-of-vids-to-show) - 1) * var(--gap))
          ) / var(--number-of-vids-to-show)
      )`};
    min-width: 0;
    @media (max-width: ${MAX_CONTENT_SCREEN_WIDTH}) {
      flex: ${({ isCompact }) => isCompact
    ? '0 0 60%'
    : `0 0 calc(
          (
              100% - (2 * 48px) -
                ((var(--number-of-vids-to-show) - 2) * var(--gap))
            ) / var(--number-of-vids-to-show)
        )`};
    }

    @media (max-width: ${MD_GRID_MAX_WIDTH}) {
      flex: ${({ isCompact }) => isCompact
    ? '0 0 60%'
    : `0 0 calc(
          (
              100% - (2 * 40px) -
                ((var(--number-of-vids-to-show) - 2) * var(--gap))
            ) / var(--number-of-vids-to-show)
        )`};
    }

    @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
      flex: 0 0 50%;
    }

    // video width is 75% of total width
    // affordance video width is (25% - 8px*2) / 2
    @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
      flex: 0 0 75%;
    }
  }
`;
//# sourceMappingURL=EmblaContainer.js.map